import { render, staticRenderFns } from "./downloadTable.vue?vue&type=template&id=2ca4b379&"
import script from "./downloadTable.vue?vue&type=script&lang=js&"
export * from "./downloadTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports